module.exports = __webpack_public_path__ + "img/2.3-戒台寺九龙松（杨树田-摄）.b21f5b69.jpg";